import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function Footer() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [glitch, setGlitch] = useState(false);
  const navigate = useNavigate();

  const openArchive = () => {
    if (glitch) return;
    setGlitch(true);
    setTimeout(() => {
      setGlitch(false);
      navigate("/archive/07");
    }, 750);
  };

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    try {
      await api.newsletter(email.trim());
      toast.success("YOU'RE ON THE LIST.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer className="bg-navy text-paper border-t border-ink/15 mt-24" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-college text-3xl">RUNRS</p>
          <p className="font-college text-lg text-yellow mt-3">PERSISTENCE &amp; LONGEVITY</p>
          <p className="text-sm text-paper/70 mt-3 max-w-xs">
            Keep showing up. Build something that lasts.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <p className="font-college text-lg text-paper/80">PAGES</p>
          <Link data-testid="footer-home" to="/" className="font-college text-xl hover:text-red transition-colors">HOME</Link>
          <Link data-testid="footer-shop" to="/shop" className="font-college text-xl hover:text-red transition-colors">SHOP</Link>
          <Link data-testid="footer-show-up" to="/show-up" className="font-college text-xl hover:text-red transition-colors">SHOW UP</Link>
          <Link data-testid="footer-about" to="/about" className="font-college text-xl hover:text-red transition-colors">ABOUT</Link>
          <Link data-testid="footer-order-lookup" to="/order-lookup" className="font-college text-xl hover:text-red transition-colors">ORDER LOOKUP</Link>
        </div>
        <div>
          <p className="font-college text-lg text-paper/80">GET THE NOTE</p>
          <p className="text-sm text-paper/70 mt-2 mb-4">Gatherings, releases, and things worth showing up for. Rarely, on purpose.</p>
          <form onSubmit={subscribe} className="flex" data-testid="newsletter-form">
            <input
              data-testid="newsletter-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 min-w-0 bg-paper text-ink px-3 py-2.5 text-sm focus:outline-none"
            />
            <button
              data-testid="newsletter-submit-button"
              type="submit"
              disabled={sending}
              className="bg-red text-paper font-college text-lg px-4 hover:bg-coral transition-colors disabled:opacity-60"
            >
              JOIN
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-paper/20">
        <div className="max-w-6xl mx-auto px-5 py-4 flex flex-col sm:flex-row justify-between gap-2 text-xs text-paper/60">
          <span className="flex flex-col sm:flex-row gap-2 sm:gap-4">
            <span>© 2026 RUNRS. MOVEMENT OVER SPECIFIED SPORT.</span>
            <span data-testid="footer-support-line">
              CONTACT:{" "}
              <a href="mailto:runrs2026@gmail.com" data-testid="footer-support-email" className="underline hover:text-paper transition-colors">
                runrs2026@gmail.com
              </a>
            </span>
          </span>
          <span className="flex items-center gap-4">
            <span>WALK. RUN. RIDE. MOVE. PARTICIPATE.</span>
            <button
              type="button"
              data-testid="footer-archive-link"
              onClick={openArchive}
              className={`text-[10px] tracking-[0.2em] transition-colors ${glitch ? "text-red/60 line-through" : "text-paper/20 hover:text-paper/35"}`}
            >
              {glitch ? "ERR // 404" : "ARCHIVE"}
            </button>
          </span>
        </div>
      </div>
    </footer>
  );
}
